export default __webpack_public_path__ + "static/media/Innovate-UK-Logo-White.480a7afc.png";